import React from 'react'
import { useLocation } from 'react-router-dom'
import { path, pathOr, includes } from 'ramda'
import useAuth from '@lib/auth'
import useComapnyCode from '@lib/hooks/useComapnyCode'

export function usePagePermission() {
  const location = useLocation()
  const { user } = useAuth()

  const urlCompanyCode = useComapnyCode()

  /**
   * 指定公司是否有讀取所有活動的權限
   */
  const hasPagePermission = React.useMemo(() => {
    if (!urlCompanyCode) {
      return true
    }

    const originalUrl = location.pathname.replace(urlCompanyCode, ':companyCode')
    const mainKey = path(['authByUrl', originalUrl, 'mainKey'], user) as any
    const actType = mainKey?.indexOf('ACT_TYPE') > -1
    if (!actType) {
      return true
    }
    /**
     * L1,L2 角色預設為允許所有活動類型
     * L3+ 是否允許所有活動類型
     * 預設為 true
     * 如果為 false，則只允許 ACT_TYPE1 和 ACT_TYPE2
     */
    const allowAllActType = pathOr(true, ['companyObj', 'allowAllActType'], user)
    const hasPermission = includes(mainKey, ['ACT_TYPE1', 'ACT_TYPE2'])

    return allowAllActType ? true : hasPermission
  }, [user, location, urlCompanyCode])

  return {
    hasPagePermission,
  }
}
